<template>
  <div>
    <!-- v-if="project!=null" class="project-container" -->
    <div v-if="supportDesign == false" class="row animated fadeIn">
      <Loading :active="true" :is-full-page="true"></Loading>
    </div>
    <b-row v-if="supportDesign" style="height:100%;" class="animated fadeIn">
      <b-col md="3" style="height:100%;">
        <b-card
          v-if="modality >= 1 && modality <= 7"
          v-tooltip="uniToolTipTranslation('S2174', 'en-US')"
          class="card-panel"
          :header="uniTranslation('S2174')"
          style="height:100%; margin-bottom: 0px !important; text-align: center;"
        >
          <button
            v-tooltip="uniToolTipTranslation('S940', 'en-US')"
            type="button"
            class="btn btn-default"
            style="max-width: 400px"
            :style="{
              backgroundColor: coloreSfondoBottoni,
              color: coloreTestoBottoni,
              borderColor: coloreBordoBottoni
            }"
            @click="doAction('createProjectDesign')"
          >
            <i class="fa fa-thermometer-full"></i>
            {{ uniTranslation("S940") }}
          </button>

          <button
            v-tooltip="uniToolTipTranslation('S938', 'en-US')"
            type="button"
            class="btn btn-default"
            style="max-width: 400px"
            :style="{
              backgroundColor: coloreSfondoBottoni,
              color: coloreTestoBottoni,
              borderColor: coloreBordoBottoni
            }"
            @click="doAction('createProjectVerify')"
          >
            <i class="fa fa-calculator"></i>
            {{ uniTranslation("TRNSL38") }}
          </button>
        </b-card>

        <b-card
          v-if="modality >= 8 && modality <= 11"
          v-tooltip="uniToolTipTranslation('S2174', 'en-US')"
          class="card-panel"
          :header="uniTranslation('S2174')"
          style="height:100%; margin-bottom: 0px !important; text-align: center;"
        >
          <!-- Q9224 -->

          <!-- Q9223 -->
          <!-- MODIFICHE DA LASCIARE -->
          <!-- 
          <button
            v-tooltip="uniToolTipTranslation('S940', 'en-US')"
            type="button"
            class="btn btn-default"
            style="max-width: 400px"
            :style="{
              backgroundColor: coloreSfondoBottoni,
              color: coloreTestoBottoni,
              borderColor: coloreBordoBottoni
            }"
            @click="doAction('createProjectPheDesign')"
          >
            <i class="fa fa-calculator"></i> {{ uniTranslation("S940") }}
          </button>
          -->
          <!-- Q9225 -->
          <button
            v-tooltip="uniToolTipTranslation('Q9223', 'en-US')"
            type="button"
            class="btn btn-default"
            style="max-width: 400px"
            :style="{
              backgroundColor: coloreSfondoBottoni,
              color: coloreTestoBottoni,
              borderColor: coloreBordoBottoni
            }"
            @click="doAction('createProjectPheSelection')"
          >
            <i class="fa fa-thermometer-full"></i>
            {{ uniTranslation("PHE834") }}
          </button>

          <button
            v-tooltip="uniToolTipTranslation('S938', 'en-US')"
            type="button"
            class="btn btn-default"
            style="max-width: 400px"
            :style="{
              backgroundColor: coloreSfondoBottoni,
              color: coloreTestoBottoni,
              borderColor: coloreBordoBottoni
            }"
            @click="doAction('createProjectPheVerify')"
          >
            <i class="fa fa-thermometer-full"></i>
            {{ uniTranslation("TRNSL38") }}
          </button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import store from "../../store";
import { mapActions, mapGetters } from "vuex";
import projectService from "../../services/backend/projectService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "CreateProjectView",
  components: {
    Loading /*,
    Notification,
    "el-dialog": Dialog,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-input": Input,
    "el-button": Button*/
  },
  data() {
    return {
      modality: 0,
      projectId: "",
      defined: false,
      supportDesign: false,
      coloreSfondoBottoni: "",
      coloreTestoBottoni: "",
      coloreBordoBottoni: ""
    };
  },
  mounted: function() {
    var that = this;
    that.$nextTick(function() {
      //alert('switching');
      if (that.defined) {
        if (that.supportDesign) {
          // show Verify/Design options and wait
        } else {
          this.$router.push({
            name: "ViewProject",
            params: {
              modality: that.modality,
              projectId: that.projectId
            }
          }).catch(()=>{});
        }
      }
    });
    that.getColoriFooterAction().then(function(data) {
      that.coloreSfondoBottoni = data[2] + " !important";
      that.coloreTestoBottoni = data[3] + " !important";
      that.coloreBordoBottoni = data[4] + " !important";
    });
  },
  beforeRouteEnter: function(to, from, next) {
    if (projectService.supportDesign(to.params.modality)) {
      next(vm => {
        vm.modality = to.params.modality;
        vm.projectId = null;
        vm.supportDesign = true;
        vm.defined = true;
      });
    } else {
      projectService
        .createProject(to.params.modality, false, true)
        .then(function(data) {
          store.dispatch("loadProject", {
            projectId: data.projectId,
            project: data
          });
          store.dispatch("resetSubViews");
          next(vm => {
            vm.modality = to.params.modality;
            vm.projectId = data.projectId;
            vm.supportDesign = false;
            vm.defined = true;
          });
        })
        .catch(function() {
          next(false);
        });
    }
  },
  methods: {
    ...mapActions("_colorsModule", ["getColoriFooterAction"]),
    ...mapActions("_prjModule", ["create", "load"]),
    ...mapActions("_commonModule", ["setLoading"]),
    doAction: function(action) {
      var that = this;
      that.supportDesign = false;
      var bNewProject = false;
      var bShowDesign = false;
      var bShowSelection = false;
      if (action == "createProjectVerify") {
        bNewProject = true;
        bShowDesign = false;
        bShowSelection = false;
      }
      if (action == "createProjectDesign") {
        bNewProject = true;
        bShowDesign = true;
        bShowSelection = false;
      }
      if (action == "createProjectPheVerify") {
        bNewProject = true;
        bShowDesign = false;
        bShowSelection = false;
      }
      if (action == "createProjectPheDesign") {
        bNewProject = true;
        bShowDesign = true;
        bShowSelection = false;
      }
      if (action == "createProjectPheSelection") {
        bNewProject = true;
        bShowDesign = false;
        bShowSelection = true;
      }
      if (bNewProject == true) {
        var payload = {};
        payload.modality = that.modality;
        payload.bShowDesign = bShowDesign;
        payload.bShowSelection = bShowSelection;

        that
          .create(payload)
          .then(function(data) {
            var innerPayload = {};

            innerPayload.projectId = data.projectId;
            innerPayload.project = data;

            that.load(innerPayload);

            that.projectId = data.projectId;

            that.$router.push({
              name: "ViewProject",
              params: {
                modality: that.modality,
                projectId: that.projectId
              }
            }).catch(()=>{});
          })
        .catch(async function(e) {
          that.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });
          const delay = ms => new Promise(res => setTimeout(res, ms));
          await delay(30000);
          that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
        });
      }
    }
  }
};
</script>

<style></style>
